module.exports = __webpack_public_path__ + "static/logotype-14c8e11c09be1a5dde7fcadcd1e8f0dd.svg";